import { yupResolver } from '@hookform/resolvers/yup';
import { enqueueSnackbar } from 'notistack';
import React from 'react';
import { Resolver, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { EExpenseType } from '../../../../shared/enums/expenses/EExpenseType';
import { handleError } from '../../../../shared/functions/handleError';
import { IExpense } from '../../../../shared/interfaces/expenses/IExpense';
import { AdminExpenseService } from '../service';
import ExpenseForm from './ExpenseForm';

export const expenseSchema = yup.object().shape({
  expenseType: yup
    .mixed<EExpenseType>()
    .oneOf(Object.values(EExpenseType))
    .required(),
  name: yup.string().required(),
  description: yup.string(),
  amount: yup.number().required(),
});
const ExpenseCreate = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { handleSubmit, control } = useForm<IExpense>({
    resolver: yupResolver(expenseSchema) as unknown as Resolver<IExpense>,
  });

  const submitHandler = (formData: IExpense) => {
    AdminExpenseService.create(formData)
      .then((response) => {
        if (response) {
          navigate(-1);
          enqueueSnackbar(
            t('toasts.successfullyCreated', { title: formData?.name }),
            {
              variant: 'success',
            },
          );
        }
      })
      .catch((err) => handleError(err));
  };

  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <ExpenseForm control={control} />
    </form>
  );
};

export default ExpenseCreate;
